import React, { useState, useEffect, useCallback } from 'react';
import { axios } from '../../context/AuthContext';
import toast from 'react-hot-toast';

export default function MufredatPage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [siniflar, setSiniflar] = useState([]);
  const [dersler, setDersler] = useState([]);
  const [secSinif, setSecSinif] = useState('');
  const [secDers, setSecDers] = useState('');
  const [konular, setKonular] = useState([]);
  const [kayitlar, setKayitlar] = useState([]);
  const [loading, setLoading] = useState(false);
  const [yeniKonu, setYeniKonu] = useState('');

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    Promise.all([axios.get('/siniflar'), axios.get('/dersler')]).then(([sRes, dRes]) => {
      if (sRes.data.success) setSiniflar(sRes.data.data);
      if (dRes.data.success) setDersler(dRes.data.data);
    });
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const loadMufredat = useCallback(async () => {
    if (!secSinif || !secDers) return;
    setLoading(true);
    try {
      const { data } = await axios.get(`/mufredat/${secSinif}/${secDers}`);
      if (data.success) {
        setKonular(data.data.konular || []);
        setKayitlar(data.data.kayitlar || []);
      }
    } catch {}
    finally { setLoading(false); }
  }, [secSinif, secDers]);

  useEffect(() => { loadMufredat(); }, [loadMufredat]);

  const toggleKonu = async (konu) => {
    const yeniDurum = konu.durum === 'islendi' ? 'islenecek' : 'islendi';
    try {
      await axios.post('/mufredat', {
        sinif_id: secSinif, ders_id: secDers,
        konu_id: konu.konu_id || null, konu_adi: konu.konu_adi,
        durum: yeniDurum, tarih: new Date().toISOString().slice(0,10),
      });
      setKonular(prev => prev.map(k => k.id === konu.id ? {...k, durum: yeniDurum} : k));
      toast.success(yeniDurum === 'islendi' ? `✅ "${konu.konu_adi}" işlendi!` : `↩️ "${konu.konu_adi}" geri alındı`);
    } catch { toast.error('Güncelleme hatası'); }
  };

  const handleYeniKonu = async () => {
    if (!yeniKonu.trim() || !secSinif || !secDers) return;
    try {
      await axios.post('/mufredat', {
        sinif_id: secSinif, ders_id: secDers,
        konu_adi: yeniKonu, durum: 'islendi',
        tarih: new Date().toISOString().slice(0,10),
      });
      toast.success('Konu işlendi olarak eklendi!');
      setYeniKonu('');
      loadMufredat();
    } catch { toast.error('Ekleme hatası'); }
  };

  const islendi = konular.filter(k => k.durum === 'islendi').length;
  const toplam  = konular.length;
  const pct     = toplam > 0 ? Math.round((islendi/toplam)*100) : 0;

  const sinifAdi   = siniflar.find(s => s.id == secSinif)?.ad || '';
  const dersAdi    = dersler.find(d => d.id == secDers)?.ad || '';
  const dersRenk   = dersler.find(d => d.id == secDers)?.renk || 'var(--blue)';

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:isMobile ? 16 : 20 }}>
      <div className="animate-fadeInUp">
        <h2 style={{ fontFamily:'var(--font-ui)', fontWeight:900, fontSize:isMobile ? '1.15rem' : '1.4rem' }}>📖 Müfredat Takibi</h2>
        <p style={{ color:'var(--text-muted)', fontSize:'0.85rem', marginTop:4 }}>Hangi konuları işlediğinizi takip edin</p>
      </div>

      {/* Filtreler */}
      <div className="card animate-fadeInUp stagger-1">
        <div style={{ display:'grid', gridTemplateColumns:isMobile ? '1fr' : '1fr 1fr', gap:14 }}>
          <div className="form-group" style={{ margin:0 }}>
            <label className="form-label">Sınıf</label>
            <select className="form-input" value={secSinif} onChange={e => setSecSinif(e.target.value)}>
              <option value="">Sınıf seçin</option>
              {siniflar.map(s => <option key={s.id} value={s.id}>{s.ad}</option>)}
            </select>
          </div>
          <div className="form-group" style={{ margin:0 }}>
            <label className="form-label">Ders</label>
            <select className="form-input" value={secDers} onChange={e => setSecDers(e.target.value)}>
              <option value="">Ders seçin</option>
              {dersler.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
            </select>
          </div>
        </div>
      </div>

      {secSinif && secDers && (
        <>
          {/* İlerleme */}
          <div className="card animate-fadeInUp" style={{ background: `linear-gradient(135deg, ${dersRenk}10, white)`, border:`1.5px solid ${dersRenk}20` }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:isMobile ? 'flex-start' : 'center', flexDirection:isMobile ? 'column' : 'row', gap:isMobile ? 10 : 0, marginBottom:12 }}>
              <div>
                <div style={{ fontFamily:'var(--font-ui)', fontWeight:900, fontSize:'1rem' }}>
                  {sinifAdi} — <span style={{ color:dersRenk }}>{dersAdi}</span>
                </div>
                <div style={{ fontSize:'0.8rem', color:'var(--text-muted)', marginTop:2 }}>
                  {islendi}/{toplam} konu işlendi
                </div>
              </div>
              <div style={{ fontFamily:'var(--font-ui)', fontWeight:900, fontSize:isMobile ? '2rem' : '2.5rem', color:dersRenk, lineHeight:1 }}>
                %{pct}
              </div>
            </div>
            <div style={{ height:10, background:'rgba(0,0,0,0.07)', borderRadius:99, overflow:'hidden' }}>
              <div style={{ height:'100%', width:`${pct}%`, background:dersRenk, borderRadius:99, transition:'width 0.6s ease' }} />
            </div>
          </div>

          {/* Konu Listesi */}
          {loading ? <div className="page-loader"><div className="spinner" /></div> : (
            <div className="card animate-fadeInUp">
              <div style={{ fontFamily:'var(--font-ui)', fontWeight:800, marginBottom:14 }}>📋 Konular</div>
              {konular.length === 0 ? (
                <div className="empty-state">
                  <p>Bu ders için konu tanımlanmamış.<br />Aşağıdan konu ekleyebilirsiniz.</p>
                </div>
              ) : (
                <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                  {konular.map((k, i) => (
                    <div key={`${k.konu_id || 'serbest'}-${k.id || i}-${i}`} onClick={() => toggleKonu(k)} style={{
                      display:'flex', alignItems:isMobile ? 'flex-start' : 'center', flexWrap:isMobile ? 'wrap' : 'nowrap', gap:12, padding:isMobile ? '12px' : '10px 14px',
                      background: k.durum==='islendi' ? '#F0FDF4' : 'var(--bg-elevated)',
                      border:`1.5px solid ${k.durum==='islendi' ? '#10B98130' : 'var(--border)'}`,
                      borderRadius:'var(--r-md)', cursor:'pointer', transition:'all 0.12s',
                    }}>
                      <div style={{
                        width:22, height:22, borderRadius:6, flexShrink:0, border:'2px solid',
                        borderColor: k.durum==='islendi' ? '#10B981' : 'var(--border-strong)',
                        background: k.durum==='islendi' ? '#10B981' : 'white',
                        display:'flex', alignItems:'center', justifyContent:'center', fontSize:'0.8rem',
                        transition:'all 0.15s',
                      }}>
                        {k.durum==='islendi' && <span style={{ color:'white', fontWeight:900 }}>✓</span>}
                      </div>
                      <div style={{ flex:1 }}>
                        <div style={{
                          fontWeight:600, fontSize:'0.875rem',
                          textDecoration: k.durum==='islendi' ? 'none' : 'none',
                          color: k.durum==='islendi' ? '#065F46' : 'var(--text-primary)',
                        }}>
                          {k.konu_adi}
                        </div>
                        {k.tarih && <div style={{ fontSize:'0.7rem', color:'var(--text-muted)', marginTop:2 }}>
                          {new Date(k.tarih).toLocaleDateString('tr-TR')}
                        </div>}
                      </div>
                      {k.durum==='islendi' && <span style={{ fontSize:'0.72rem', fontWeight:700, color:'#10B981', background:'#D1FAE5', padding:'2px 8px', borderRadius:99, marginLeft:isMobile ? 34 : 0 }}>✓ İşlendi</span>}
                    </div>
                  ))}
                </div>
              )}

              {/* Yeni konu ekle */}
              <div style={{ marginTop:16, display:'flex', gap:10, flexDirection:isMobile ? 'column' : 'row' }}>
                <input className="form-input" style={{ flex:1 }} placeholder="Serbest konu ekle..." value={yeniKonu}
                  onChange={e => setYeniKonu(e.target.value)}
                  onKeyDown={e => e.key==='Enter' && handleYeniKonu()} />
                <button className="btn btn-primary" onClick={handleYeniKonu} style={{ paddingInline:20, justifyContent:'center' }}>+ Ekle</button>
              </div>
            </div>
          )}

          {/* Son kayıtlar */}
          {kayitlar.length > 0 && (
            <div className="card animate-fadeInUp">
              <div style={{ fontFamily:'var(--font-ui)', fontWeight:800, marginBottom:12 }}>📅 Son İşlenen Konular</div>
              <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                {kayitlar.slice(0,8).map((k, i) => (
                  <div key={i} style={{ display:'flex', justifyContent:'space-between', flexDirection:isMobile ? 'column' : 'row', gap:isMobile ? 4 : 12, padding:'8px 12px', background:'var(--bg-elevated)', borderRadius:8, fontSize:'0.82rem' }}>
                    <span style={{ fontWeight:600 }}>{k.konu_adi}</span>
                    <span style={{ color:'var(--text-muted)' }}>{new Date(k.tarih).toLocaleDateString('tr-TR')}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
